"use strict";
//: удаление ламп со страницы 
Object.defineProperty(exports, "__esModule", { value: true });
const deleteLamps = () => {
    try {
        const lampsBlock = document.querySelector('#box-for-lamp');
        lampsBlock.innerHTML = '';
        //console.log('delete lamps');
    }
    catch (error) {
        console.log(error);
    }
};
exports.default = deleteLamps;
